import React from 'react';
import cx from 'classnames';
import s from './Logout.module.scss';
import { stopPropagation } from '../../shared/utils/utils';

export interface IProps {
    className?: string;
    loading?: boolean;
    userName: string;
    onClose?: () => void;
    onLogout: () => void;
}

export const Logout: React.FC<IProps> = (props) => (
    <div className={cx(s.container, props.className)} onClick={props.onClose}>
        <div className={s.content} onClick={stopPropagation}>
            <div className={s.body}>
                <div className={s.title}>Обліковий запис</div>

                <div className={s.userName}>{props.userName || ''}</div>
            </div>

            <div className={s.footer}>
                <div className={cx(s.btnLogout, { disabled: props.loading })} onClick={props.onLogout}>
                    Вийти з системи
                </div>
            </div>
        </div>
    </div>
);

export default Logout;
